import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { API_BASE_URL } from '../scripts/control';
import { linkifyContent } from '../../../utils/linkifyHtml';
import OptimizedImage from '../../../components/OptimizedImage';

const TalkDetail = () => {
    const { idtalk } = useParams(); // Obtenida de la URL
    const [talk, setTalk] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!idtalk) {
            setError('ID de congreso/seminario no proporcionado');
            return;
        }

        fetch(`${API_BASE_URL}/api/details.php?type=talk&id=${idtalk}`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.text();
            })
            .then((text) => {
                const trimmed = text ? text.trim() : '';
                if (!trimmed) {
                    throw new Error('El servidor no devolvió datos (respuesta vacía). Comprueba que api/details.php existe y devuelve JSON.');
                }
                try {
                    return JSON.parse(trimmed);
                } catch {
                    throw new Error('El servidor no devolvió JSON válido. Revisa api/details.php.');
                }
            })
            .then((data) => {
                if (data.success && data.data) {
                    setTalk(data.data);
                } else if (data.error) {
                    setError(data.error);
                } else {
                    setError('No se pudo obtener la información del congreso/seminario');
                }
            })
            .catch((error) => {
                setError('Error al obtener los detalles del congreso/seminario: ' + error.message);
            });
    }, [idtalk]);

    const formatDate = (dateString) => {
        if (!dateString || dateString === '0000-00-00') return '';
        const [year, month, day] = dateString.split('-');
        return `${day}-${month}-${year}`;
    };

    const formatTime = (timeString) => {
        if (!timeString || timeString === '00:00:00') return '';
        // Si viene como "HH:MM:SS", solo mostrar "HH:MM"
        return timeString.substring(0, 5);
    };

    if (error) {
        return (
            <div style={{ maxWidth: '900px', margin: '20px auto', padding: '20px' }}>
                <div className="alert alert-danger" role="alert">
                    <strong>Error:</strong> {error}
                </div>
            </div>
        );
    }

    if (!talk) {
        return (
            <div style={{ maxWidth: '900px', margin: '20px auto', padding: '20px', textAlign: 'center' }}>
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                </div>
                <p style={{ marginTop: '10px' }}>Cargando detalles del congreso/seminario...</p>
            </div>
        );
    }

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <div className="card" style={{ maxWidth: '900px', margin: '20px auto', padding: '20px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
            <div className="card-body m-2">
                <h1 className="card-title">{talk.title}</h1>
                <OptimizedImage
                    src={talk.img_url
                        ? `${API_BASE_URL}/public/uploads/images/${talk.img_url}`
                        : `${API_BASE_URL}/public/uploads/images/comic.jpg`}
                    alt={talk.img_alt || 'Imagen del congreso/seminario'}
                    style={{ width: '100%', maxHeight: '400px', marginBottom: '20px', marginLeft: '-2%' }}
                    loading="lazy"
                    aspectRatio={16/9}
                    wrapperClassName="optimized-image-detail-hero"
                />
                {/* Contenido HTML sanitizado para evitar XSS y contenido malicioso (Safe Browsing) */}
                <div
                  className="talk-body"
                  dangerouslySetInnerHTML={{ __html: linkifyContent(talk.body || '') }}
                />
                
                {talk.location && (
                    <div className="card-text">
                        <strong>Ubicación:</strong>
                        <div dangerouslySetInnerHTML={{ __html: talk.location }} />
                    </div>
                )}
                
                {talk.day && talk.day !== '0000-00-00' && (
                    <p className="card-text">
                        <strong>Fecha:</strong> {formatDate(talk.day)}
                    </p>
                )}

                {talk.hour && talk.hour !== '00:00:00' && (
                    <p className="card-text">
                        <strong>Hora:</strong> {formatTime(talk.hour)}
                    </p>
                )}

                <button
                    className="btn btn-primary"
                    style={{ marginTop: '20px', padding: '10px 20px', backgroundColor: '#005EC4', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
                     onClick={scrollToTop}
                >
                    Subir
                </button>
            </div>
        </div>
    );
};

export default TalkDetail;
